import * as React from "react";
import Breadcrumbs from "../core/Breadcrumbs";
import { Link } from "react-router-dom";
// import Card from "../core/Card";
import ModernCard from "../core/ModernCard";
import { useContext, useMemo } from "react";
import usePromise from "../hooks/usePromise";
import { getOrgUsers } from "../../libs/organization";
import AddSalespersonModal from "./AddSalespersonModal";
import { RailsUserContext } from "../../libs/user_context";
import CommissionOrgConfig from "./CommissionOrgConfig";
import CommissionsMonthStatus from "./CommissionsMonthStatus";
import {
  getCommissionOrgConfig,
  getCommissionsByStatus,
} from "../../libs/commission_calculator";
import Loader from "../core/Loader";
import CommissionDashboardManager from "./dashboard/CommissionDashboardManager";
import styled from "styled-components";
import * as moment from "moment";
import MonthStatusLabel from "./MonthStatusLabel";

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 735px) {
    flex-direction: column;
  }
`;

const ColumnItem = styled.div`
  flex-direction: column;
  width: 49%;
  height: 100%;
  @media (max-width: 735px) {
    width: 100%;
  }
`;

const NeedsReviewSectionContainer = styled.div`
  padding: 10px;
  background-color: #e6eff2;
  margin-bottom: 10px;
`;

const SalesPersonSectionContainer = styled.div`
  padding: 5px;
  margin-top: 5px;
`;

interface IProps {
  org: IOrganization;
}

function CommissionCalculatorIndex({ org }: IProps) {
  const [users, usersPromise] = usePromise(() => getOrgUsers(org.id), [org]);

  const salespeople = useMemo(
    () => (users ? users.filter(u => u.roles.includes("sales")) : []),
    [users]
  );

  const [config, configPromise] = usePromise(
    () => getCommissionOrgConfig(org.id),
    [org]
  );

  const [needsReviewCommissions, needsReviewCommissionsPromise] = usePromise(
    () => getCommissionsByStatus(org.id, "needs_review")
  );

  return (
    <>
      <Breadcrumbs crumbs={[{ label: "Commission Calculator" }]} />
      <CommissionIndexNav users={users} usersPromise={usersPromise} />
      <CommissionDashboardManager salespeople={salespeople} />
      <ColumnContainer>
        <ColumnItem>
          <CommissionsMonthStatus
            orgConfig={config}
            orgId={org.id}
            salespeopleCount={salespeople.length}
          />
        </ColumnItem>
        <ColumnItem>
          <SalespeopleTable
            salespeople={salespeople}
            needsReviewCommissions={needsReviewCommissions}
            needsReviewCommissionsPromise={needsReviewCommissionsPromise}
          />
          {configPromise.loading ? (
            <Loader />
          ) : (
            <CommissionOrgConfig
              config={config}
              configPromise={configPromise}
            />
          )}
        </ColumnItem>
      </ColumnContainer>
    </>
  );
}

export default CommissionCalculatorIndex;

function CommissionIndexNav({ users, usersPromise }) {
  const { user: currentUser } = useContext(RailsUserContext);

  return (
    <div className="level">
      <div className="level-left">
        <div className="level-item">
          <Link to={"/configs"} className={"btn btn-default"}>
            <i className="fa fa-cogs" /> Configurations
          </Link>
        </div>
        <div className="level-item">
          <Link to={"/tester"} className={"btn btn-default"}>
            <i className="fa fa-calculator" /> Tester
          </Link>
        </div>
        <div className="level-item">
          <AddSalespersonModal users={users} usersPromise={usersPromise} />
        </div>
        {currentUser.isAdmin && (
          <div className="level-item">
            <Link to={"/admin"} className={"btn btn-default"}>
              <i className="fa fa-user-secret" /> Admin
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

function SalespeopleTable({
  salespeople,
  needsReviewCommissions,
  needsReviewCommissionsPromise,
}) {
  return (
    <ModernCard title={"View Commissions"} ta="left" m="0px">
      {needsReviewCommissionsPromise.loading ? (
        <Loader />
      ) : (
        <>
          {needsReviewCommissions &&
            Array.isArray(needsReviewCommissions) &&
            needsReviewCommissions.length > 0 && (
              <NeedsReviewSectionContainer>
                <h4>Commissions that Need Review</h4>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Month</th>
                      <th>Status</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {needsReviewCommissions.map(month => {
                      return (
                        <tr key={`${month.id}`}>
                          <td>{month.user.name}</td>
                          <td>{moment(month.month).format("MMMM YYYY")}</td>
                          <td>
                            <MonthStatusLabel
                              userApprovalStatus={month.userApproval}
                            />
                          </td>
                          <td>
                            <Link
                              className={"btn btn-default btn-sm"}
                              to={`/salespeople/${month.user.id}/${month.id}`}
                            >
                              <i className="fa fa-eye" /> View
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </NeedsReviewSectionContainer>
            )}
          <SalesPersonSectionContainer>
            <h4>View Commissions by SalesPerson</h4>
            <table className="table">
              <thead>
                <tr>
                  <th>Name:</th>
                </tr>
              </thead>
              <tbody>
                {salespeople.map(user => (
                  <tr key={user.id}>
                    <td>
                      <Link to={`/salespeople/${user.id}`}>{user.name}</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </SalesPersonSectionContainer>
        </>
      )}
    </ModernCard>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionCalculatorIndex.tsx